import type { ReactNode } from 'react';
import { Button } from '../button';
import { Modal, ModalFooter, ModalHeader } from '../modal';
import css from './confirm-delete-modal.module.scss';

type ConfirmDeleteModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isPending: boolean;
  title: string;
  children?: ReactNode;
  error?: string | null;
  // Disable the confirm action without implying a delete is in flight (e.g.
  // no row selected). `isPending` drives the "Deleting…" label; `disabled`
  // only greys the button out while keeping it labelled "Delete".
  disabled?: boolean;
};

export const ConfirmDeleteModal = ({
  open,
  onClose,
  onConfirm,
  isPending,
  title,
  children,
  error,
  disabled = false,
}: ConfirmDeleteModalProps) => (
  <Modal onClose={onClose} open={open}>
    <ModalHeader onClose={onClose} title={title} />
    <div className={css.body}>
      {children}
      {error && <p className={css.error}>{error}</p>}
    </div>
    <ModalFooter>
      <Button disabled={isPending} onClick={onClose} variant="ghost">
        Cancel
      </Button>
      <Button
        disabled={isPending || disabled}
        onClick={onConfirm}
        variant="destructive"
      >
        {isPending ? 'Deleting…' : 'Delete'}
      </Button>
    </ModalFooter>
  </Modal>
);
